import { RouteLocationNormalized, NavigationGuardNext } from 'vue-router';
import { accountCheck, RESULTCODE } from '@tencent/vb-web-base/dist/accountTips';
import { CheckNoTeslaWhiteAndIsElectricCar, CheckCarOwnerRight, GetRightList, GetRightActDate } from '@common/core/network/activityAPI';
import { useGlobalState } from '../store/carOwnerRight';
const state = useGlobalState();

async function checkTeslaRightStatus(to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext): Promise<void> {
  if (from.path === '/rightMy' || to.query.isActive) {
    return next();
  }
  const res = await accountCheck({
    needAutoLogin:true,
    loginReload:true,
    needActivateModal:true,
    needOpenModal:false
  });
  if (res.code === RESULTCODE.LOGINRELOAD) {
    return;
  }
  if (res.code !== RESULTCODE.SUCCESS){
    // if (res.code === RESULTCODE.NOACCOUNT) {
    //   return next();
    // }
    // 检测不成功 组件会走其他异常流程比如拉起开户 激活弹层
    return next();
  }
  try {
    const [{ date = [] }, rightList] = await Promise.all([GetRightActDate('tesla'), GetRightList('tesla')]);
    const limitFloor = rightList.find((item) => item.rankIndex === '1')?.limitFloor;
    state.value.date = date;
    state.value.allTeslaRightList = rightList;
    // const userStatus = await CheckLoanStatus({
    //   proNo: ProductInfoMap.TESLA,
    //   baseProNo: BaseProductNoMap.TESLA,
    //   startTime: date[0],
    //   endTime: date[1],
    // });
    const userStatus = await CheckCarOwnerRight({
      brand: 'tesla',
      startTime: date[0],
      endTime: date[1],
    });
    state.value.userStatus = userStatus;
    if (userStatus.loanAmount < Number(limitFloor)) {
      return next({
        path: to.path,
        query: {
          ...from.query,
          isActive: !userStatus.loanAmount ? '0' : '1'
        },
      });
    }
    return next({
      path: '/rightMy',
      query: {
        ...from.query,
        loanAmount: userStatus.loanAmount,
        overdue: userStatus.overdue ? '0' : '1',
        prepay: userStatus.prepay ? '0' : '1',
        writeOff: userStatus.writeOff ? '0' : '1',
        brand: 'tesla',
      },
    });
  } catch (err) {
    return next();
  }
}

async function checkOtherRightStatus(to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext): Promise<void> {
  if (from.path === '/rightMy' || to.query.isAuth) {
    return next();
  }
  const res = await accountCheck({
    needAutoLogin:true,
    loginReload:true,
    needActivateModal:true,
    needOpenModal:false
  });
  if (res.code === RESULTCODE.LOGINRELOAD) {
    return;
  }
  if (res.code !== RESULTCODE.SUCCESS){
    // if (res.code === RESULTCODE.NOACCOUNT) {
    //   return next();
    // }
    // 检测不成功 组件会走其他异常流程比如拉起开户 激活弹层
    return next();
  }
  try {
    const { isInNoTeslaWhite, isElectricCar } = await CheckNoTeslaWhiteAndIsElectricCar();
    if (!isInNoTeslaWhite) {
      return next({
        path: to.path,
        query: {
          ...from.query,
          // 表示不在非tesla车主白名单中
          isAuth: '1',
        },
      });
    }
    const [{ date = [] }, rightList] = await Promise.all([GetRightActDate('other'), GetRightList('other')]);
    const limitFloor = rightList.find((item) => item.rankIndex === '1')?.limitFloor;
    state.value.date = date;
    state.value.allOtherRightList = rightList;
    const userStatus = await CheckCarOwnerRight({
      brand: 'other',
      startTime: date[0],
      endTime: date[1],
    });
    state.value.userStatus = userStatus;
    if (userStatus.loanAmount < Number(limitFloor)) {
      return next({
        path: to.path,
        query: {
          ...from.query,
          isAuth: '0',
          isActive: !userStatus.loanAmount ? '0' : '1'
        },
      });
    }
    return next({
      path: '/rightMy',
      query: {
        ...from.query,
        loanAmount: userStatus.loanAmount,
        overdue: userStatus.overdue ? '0' : '1',
        prepay: userStatus.prepay ? '0' : '1',
        writeOff: userStatus.writeOff ? '0' : '1',
        brand: 'other',
        isElectricCar: isElectricCar ? '0' : '1',
      },
    });
  } catch (err) {
    return next();
  }
}

export {
  checkTeslaRightStatus,
  checkOtherRightStatus
};
